import type { RemirrorJSON } from '@remirror/core';
import type { ChatMention } from '@trinity/chat';
import { extractMentionsFromDoc } from './extract-mentions';
import { getPlainTextFromDoc } from './get-plain-text';

export type RemirrorTransformResult = {
  text: string;
  mentions: ChatMention[];
};

export function transformRemirrorState(doc: RemirrorJSON): RemirrorTransformResult {
  return {
    text: getPlainTextFromDoc(doc),
    mentions: extractMentionsFromDoc(doc),
  };
}
